import React from "react";
import {
  Tab,
  Tabs,
  Table,
} from "react-bootstrap";
import CandidateCard from "./CandidateCard";
import SuggestedCandidates from "./SuggestedCandidates";

function  KanbanCandidatesTable({ suggestedCandidates,
  suggestedCandidatesLoading,
  onViewCandidateProfileClick, candidatesList, currentTabHandler, currentTab, changeStageHandler, stageLoading, userType
}) {

  return (
      <Tabs defaultActiveKey="Candidates" className="mb-3">
        <Tab eventKey="Candidates" title="Candidates">
          <div className="d-flex align-items-start justify-content-between border border-radius-10 bg-white border-radius-10 w-100">
            <div className="w-100">
              <Tabs activeKey={currentTab} onSelect={currentTabHandler} className="custom-tabs border border-radius-10">
                <Tab eventKey="applied" title="Applied">
                  <Table responsive="lg" className="custom-table mentor-table">
                    <thead>
                      <tr>
                        <th>Candidate Name</th>
                        <th>Skills</th>
                        <th>Applied On</th>
                        <th>Resume</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <CandidateCard candidatesList={candidatesList} changeStageHandler={changeStageHandler}  stageLoading={stageLoading} userType={userType}/>
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="assessment" title="Assessment">
                  <Table responsive="lg" className="custom-table mentor-table">
                    <thead>
                      <tr>
                        <th>Candidate Name</th>
                        <th>Skills</th>
                        <th>Submitted On</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <CandidateCard candidatesList={candidatesList} changeStageHandler={changeStageHandler}  stageLoading={stageLoading} userType={userType}/>
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="interview" title="Interview">
                  <Table responsive="lg" className="custom-table mentor-table">
                    <thead>
                      <tr>
                        <th>Candidate Name</th>
                        <th>Skills</th>
                        <th>Last assessed</th>
                        <th>Status</th>
                        {userType == "mentor" ? null : <th>Action</th> }
                      </tr>
                    </thead>
                    <tbody>
                      <CandidateCard candidatesList={candidatesList} changeStageHandler={changeStageHandler}  stageLoading={stageLoading} userType={userType}/>
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="offer" title="Offer">
                  <Table responsive="lg" className="custom-table mentor-table">
                    <thead>
                      <tr>
                        <th>Candidate Name</th>
                        <th>Skills</th>
                        <th>Created On</th>
                        <th>Status</th>
                        {userType == "mentor" ? null : <th>Action</th> }
                      </tr>
                    </thead>
                    <tbody>
                      <CandidateCard candidatesList={candidatesList} changeStageHandler={changeStageHandler} stageLoading={stageLoading} userType={userType}/>
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="hired" title="Hired">
                  <Table responsive="lg" className="custom-table mentor-table">
                    <thead>
                      <tr>
                        <th>Candidate Name</th>
                        <th>Skills</th>
                        <th>Last assessed</th>
                        <th>Status</th>
                        {userType == "mentor" ? null : <th>Action</th> }
                      </tr>
                    </thead>
                    <tbody>
                      <CandidateCard candidatesList={candidatesList} changeStageHandler={changeStageHandler} stageLoading={stageLoading} userType={userType}/>
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="rejected" title="Rejected">
                  <Table responsive="lg" className="custom-table mentor-table">
                    <thead>
                      <tr>
                        <th>Candidate Name</th>
                        <th>Skills</th>
                        <th>Last assessed</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <CandidateCard candidatesList={candidatesList} changeStageHandler={changeStageHandler} stageLoading={stageLoading} userType={userType}/>
                    </tbody>
                  </Table>
                </Tab>
              </Tabs>
            </div>
          </div>
        </Tab>

        <Tab eventKey="SuggestedCandidates" title="Suggested Candidates">
          <SuggestedCandidates
            suggestedCandidates={suggestedCandidates}
            suggestedCandidatesLoading={suggestedCandidatesLoading}
            onViewCandidateProfileClick={onViewCandidateProfileClick}
          />
        </Tab>
      </Tabs>
  );
}

export default  KanbanCandidatesTable;
